import StudentReportView from './component';
import _routes from './routes';

export const routes = _routes;
export default StudentReportView;



// WEBPACK FOOTER //
// ./containers/Group/UnitReportHFv4/StudentReportView/index.js